// Version : 1.0.0
// Author : AGALYA
import FamilyActionType from './family-details.types';

/** ***************** FAMILY MEMBER COUNT DATA START *********************** */
export const familyMemberCountDataStart = (saveData: any) => ({
	type: FamilyActionType.FAMILY_MEMBER_COUNT_CHANGED,
	payload: saveData,
});

/** ***************** FAMILY MEMBER ADD START *********************** */
export const addFamilyMemberStart = (saveData: any) => ({
	type: FamilyActionType.ADD_FAMILY_MEMBER_START,
	payload: saveData,
});
/** ***************** FAMILY MEMBER ADD END *********************** */

/** ***************** FAMILY MEMBER REMOVE START *********************** */
export const removeFamilyMemberStart = (saveData: any) => ({
	type: FamilyActionType.REMOVE_FAMILY_MEMBER_START,
	payload: saveData,
});
/** ***************** FAMILY MEMBER REMOVE END *********************** */

/** ***************** FAMILY MEMBER INCOME START *********************** */
export const familyIncomeStart = (familyIncomeAddCredentials: any) => ({
	type: FamilyActionType.FAMILY_MEMBER_INCOME_START,
	payload: familyIncomeAddCredentials,
});

export const familyIncomeSuccess = (familyIncomeAddSuccess: any) => ({
	type: FamilyActionType.FAMILY_MEMBER_INCOME_SUCCESS,
	payload: familyIncomeAddSuccess,
});

export const familyIncomeFailure = (familyIncomeAddFailure: unknown) => ({
	type: FamilyActionType.FAMILY_MEMBER_INCOME_FAILURE,
	payload: familyIncomeAddFailure,
});

export const familyIncomeResponseResetStart = () => ({
	type: FamilyActionType.FAMILY_MEMBER_INCOME_RESPONSE_REST_START,
});

export const familyIncomeUserResponseChanged = () => ({
	type: FamilyActionType.FAMILY_MEMBER_INCOME_RESPONSE_CHANGED,
});
/** ***************** FAMILY MEMBER INCOME END *********************** */

export const setFamilyArrStart = (familyArr: any) => ({
	type: FamilyActionType.SET_FAMILY_MEMBER_ARR_START,
	payload: familyArr,
});

/** ***************** FAMILY FETCH START *********************** */
export const fetchFamilyMemberStart = (familyCredentials: any) => ({
	type: FamilyActionType.FETCH_FAMILY_MEMBERS_START,
	payload: familyCredentials,
});

export const fetchFamilyMemberSuccess = (familySuccess: any) => ({
	type: FamilyActionType.FETCH_FAMILY_MEMBERS_SUCCESS,
	payload: familySuccess,
});

export const fetchFamilyMemberFailure = (familyFailure: unknown) => ({
	type: FamilyActionType.FETCH_FAMILY_MEMBERS_FAILURE,
	payload: familyFailure,
});

export const fetchFamilyMemberResponseResetStart = () => ({
	type: FamilyActionType.FETCH_FAMILY_MEMBERS_RESPONSE_REST_START,
});

export const fetchFamilyMemberUserResponseChanged = () => ({
	type: FamilyActionType.FETCH_FAMILY_MEMBERS_RESPONSE_CHANGED,
});
/** ***************** FAMILY FETCH END *********************** */

/** ***************** FAMILY ADD START *********************** */
export const familyMemberAddStart = (familyCredentials: any) => ({
	type: FamilyActionType.ADD_FAMILY_MEMBERS_START,
	payload: familyCredentials,
});

export const familyMemberAddSuccess = (familySuccess: any) => ({
	type: FamilyActionType.ADD_FAMILY_MEMBERS_SUCCESS,
	payload: familySuccess,
});

export const familyMemberAddFailure = (familyFailure: unknown) => ({
	type: FamilyActionType.ADD_FAMILY_MEMBERS_FAILURE,
	payload: familyFailure,
});

export const familyMemberAddResponseResetStart = () => ({
	type: FamilyActionType.ADD_FAMILY_MEMBERS_RESPONSE_REST_START,
});

export const familyMemberAddResponseChanged = () => ({
	type: FamilyActionType.ADD_FAMILY_MEMBERS_RESPONSE_CHANGED,
});
/** ***************** FAMILY ADD END *********************** */

/** ***************** FETCH PARTICULAR FAMILY MEMBER START *********************** */
export const fetchParticularFamMemberStart = (familyCredentials: any) => ({
	type: FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_START,
	payload: familyCredentials,
});

export const fetchParticularFamSuccess = (familySuccess: any) => ({
	type: FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_SUCCESS,
	payload: familySuccess,
});

export const fetchParticularFamFailure = (familyFailure: unknown) => ({
	type: FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_FAILURE,
	payload: familyFailure,
});

export const fetchParticularFamResponseResetStart = () => ({
	type: FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_RESPONSE_REST_START,
});

export const fetchParticularFamObjResetStart = () => ({
	type: FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_OBJ_RESET,
});

export const fetchParticularFamResponseChanged = () => ({
	type: FamilyActionType.FETCH_PARTICULAR_FAMILY_MEMBERS_RESPONSE_CHANGED,
});
/** ***************** FETCH PARTICULAR FAMILY MEMBER END *********************** */

/** ***************** DELETE PARTICULAR FAMILY MEMBER START *********************** */
export const deleteFamilyMemberStart = (familyCredentials: any) => ({
	type: FamilyActionType.DELETE_FAMILY_MEMBERS_START,
	payload: familyCredentials,
});

export const deleteFamilySuccess = (familySuccess: any) => ({
	type: FamilyActionType.DELETE_FAMILY_MEMBERS_SUCCESS,
	payload: familySuccess,
});

export const deleteFamilyFailure = (familyFailure: unknown) => ({
	type: FamilyActionType.DELETE_FAMILY_MEMBERS_FAILURE,
	payload: familyFailure,
});

export const deleteFamilyResponseResetStart = () => ({
	type: FamilyActionType.DELETE_FAMILY_MEMBERS_RESPONSE_REST_START,
});

export const deleteFamilyResponseChanged = () => ({
	type: FamilyActionType.DELETE_FAMILY_MEMBERS_RESPONSE_CHANGED,
});
/** ***************** DELETE PARTICULAR FAMILY MEMBER END *********************** */

/** ***************** VERIFY AADHAR OTP DETAILS START *********************** */
export const verifyFamilyAadharOtpStart = (DetailsCredentials: any) => ({
	type: FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_START,
	payload: DetailsCredentials,
});

export const verifyFamilyAadharOtpSuccess = (DetailsSuccess: any) => ({
	type: FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_SUCCESS,
	payload: DetailsSuccess,
});

export const verifyFamilyAadharOtpFailure = (DetailsFailure: unknown) => ({
	type: FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_FAILURE,
	payload: DetailsFailure,
});

export const verifyFamilyAadharOtpResponseResetStart = () => ({
	type: FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_RESPONSE_RESET_START,
});

export const verifyFamilyAadharOtpResponseChanged = () => ({
	type: FamilyActionType.VERIFY_FAMILY_AADHAR_OTP_RESPONSE_CHANGED,
});

/** ***************** VERIFY AADHAR VALIDATE OTP DETAILS START *********************** */
export const verifyValidateFamilyAadharOtpStart = (DetailsCredentials: any) => ({
	type: FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_START,
	payload: DetailsCredentials,
});

export const verifyValidateFamilyAadharOtpSuccess = (DetailsSuccess: any) => ({
	type: FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_SUCCESS,
	payload: DetailsSuccess,
});

export const verifyValidateFamilyAadharOtpFailure = (DetailsFailure: unknown) => ({
	type: FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_FAILURE,
	payload: DetailsFailure,
});

export const verifyValidateFamilyAadharOtpResponseResetStart = () => ({
	type: FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_RESPONSE_RESET_START,
});

export const verifyValidateFamilyAadharOtpResponseChanged = () => ({
	type: FamilyActionType.VERIFY_VALIDATE_FAMILY_AADHAR_OTP_RESPONSE_CHANGED,
});
/** ***************** VERIFY AADHAR VALIDATE OTP DETAILS END *********************** */